
import { UserPersona } from '@/types/user';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';

type RoleSelectionStepProps = {
  selectedPersona: UserPersona;
  setSelectedPersona: (persona: UserPersona) => void;
};

const RoleSelectionStep = ({ selectedPersona, setSelectedPersona }: RoleSelectionStepProps) => {
  return (
    <RadioGroup 
      value={selectedPersona} 
      onValueChange={(value) => setSelectedPersona(value as UserPersona)} 
      className="space-y-4"
    >
      <div className="flex items-center space-x-2 border p-4 rounded-md hover:bg-muted/50 cursor-pointer">
        <RadioGroupItem value="independentSolo" id="independentSolo" />
        <Label htmlFor="independentSolo" className="flex-1 cursor-pointer">
          <div className="font-medium">Independent User</div>
          <div className="text-sm text-muted-foreground">Personal use - track your growth independently</div>
        </Label>
      </div>
      
      <div className="flex items-center space-x-2 border p-4 rounded-md hover:bg-muted/50 cursor-pointer">
        <RadioGroupItem value="newTeamMember" id="newTeamMember" />
        <Label htmlFor="newTeamMember" className="flex-1 cursor-pointer">
          <div className="font-medium">Join as Team Member</div>
          <div className="text-sm text-muted-foreground">I'm joining or creating an organization team</div>
        </Label>
      </div>
      
      <div className="flex items-center space-x-2 border p-4 rounded-md hover:bg-muted/50 cursor-pointer">
        <RadioGroupItem value="manager" id="manager" />
        <Label htmlFor="manager" className="flex-1 cursor-pointer">
          <div className="font-medium">Team Manager</div>
          <div className="text-sm text-muted-foreground">Lead a team while tracking your own growth</div>
        </Label>
      </div>
      
      <div className="flex items-center space-x-2 border p-4 rounded-md hover:bg-muted/50 cursor-pointer">
        <RadioGroupItem value="organizationAdmin" id="organizationAdmin" />
        <Label htmlFor="organizationAdmin" className="flex-1 cursor-pointer">
          <div className="font-medium">Organization Admin</div>
          <div className="text-sm text-muted-foreground">Manage teams and members in your organization</div>
        </Label>
      </div>
      
      <div className="flex items-center space-x-2 border p-4 rounded-md hover:bg-muted/50 cursor-pointer">
        <RadioGroupItem value="admin" id="admin" />
        <Label htmlFor="admin" className="flex-1 cursor-pointer">
          <div className="font-medium">Platform Administrator</div>
          <div className="text-sm text-muted-foreground">Manage the Step platform and all organizations</div>
        </Label>
      </div>
    </RadioGroup>
  );
};

export default RoleSelectionStep;
